/**
 * @Component
 * Components for Page Not Found page
 *
 */

import { Component } from '@angular/core';


@Component({
  selector: 'pagenotfound',
  templateUrl: './pagenotfound.component.html'
})

export class PageNotFoundComponent {
}



// WEBPACK FOOTER //
// ./src/app/pagenotfound/pagenotfound.component.ts